"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fr = void 0;
exports.fr = {
    byte: "octet",
    bytes: "octets",
    kiloBytes: "Ko",
    megaBytes: "Mo",
    gigaBytes: "Go",
    teraBytes: "To",
};
//# sourceMappingURL=fr.js.map